/**
 * Adresses des écrans du lot **L08 — Agents gouvernés et IA souveraine** (ADR 0080), un seul
 * endroit. Deux niveaux, comme au contrat :
 *   - le LOCATAIRE porte la passerelle LLM (fournisseurs, modèles, budgets, journal) et les
 *     politiques d'agents (`/llm/*`, `/agent-policies`) ;
 *   - le PROJET porte ses clés de passerelle, ses index documentaires, ses validations et le fil de
 *     ses agents (`project_id` des opérations).
 */
const enc = encodeURIComponent;

export const LLM_TABS = ['models', 'budgets', 'usages'] as const;
export type LlmTab = (typeof LLM_TABS)[number];
export const asLlmTab = (value: unknown): LlmTab => LLM_TABS.find((tab) => tab === value) ?? 'models';

export const AGENTS_TABS = ['agents', 'validations'] as const;
export type AgentsTab = (typeof AGENTS_TABS)[number];
export const asAgentsTab = (value: unknown): AgentsTab =>
  AGENTS_TABS.find((tab) => tab === value) ?? 'agents';

export const INDEX_TABS = ['chat', 'search', 'documents', 'summary'] as const;
export type IndexTab = (typeof INDEX_TABS)[number];
export const asIndexTab = (value: unknown): IndexTab => INDEX_TABS.find((tab) => tab === value) ?? 'chat';

export const POLICY_TABS = ['summary', 'definition', 'activity'] as const;
export type PolicyTab = (typeof POLICY_TABS)[number];
export const asPolicyTab = (value: unknown): PolicyTab =>
  POLICY_TABS.find((tab) => tab === value) ?? 'summary';

export const DETAIL_TABS = ['summary', 'definition'] as const;
export type DetailTabId = (typeof DETAIL_TABS)[number];
export const asDetailTab = (value: unknown): DetailTabId =>
  DETAIL_TABS.find((tab) => tab === value) ?? 'summary';

const project = (tenant: string, projectId: string) => `/${tenant}/projects/${enc(projectId)}`;

export const aiHref = {
  llm: (tenant: string) => `/${tenant}/llm`,
  newProvider: (tenant: string) => `/${tenant}/llm/providers/new`,
  provider: (tenant: string, id: string) => `/${tenant}/llm/providers/${enc(id)}`,
  newModel: (tenant: string) => `/${tenant}/llm/models/new`,
  model: (tenant: string, id: string) => `/${tenant}/llm/models/${enc(id)}`,
  budget: (tenant: string, projectId: string) => `/${tenant}/llm/budgets/${enc(projectId)}`,

  policies: (tenant: string) => `/${tenant}/agent-policies`,
  newPolicy: (tenant: string) => `/${tenant}/agent-policies/new`,
  policy: (tenant: string, id: string) => `/${tenant}/agent-policies/${enc(id)}`,

  llmKeys: (tenant: string, projectId: string) => `${project(tenant, projectId)}/llm-keys`,
  assistant: (tenant: string, projectId: string) => `${project(tenant, projectId)}/assistant`,
  newIndex: (tenant: string, projectId: string) => `${project(tenant, projectId)}/assistant/new`,
  index: (tenant: string, projectId: string, indexId: string) =>
    `${project(tenant, projectId)}/assistant/${enc(indexId)}`,
  agents: (tenant: string, projectId: string) => `${project(tenant, projectId)}/agents`,
  approval: (tenant: string, projectId: string, approvalId: string) =>
    `${project(tenant, projectId)}/approvals/${enc(approvalId)}`,
  codeAssistant: (tenant: string, projectId: string) => `${project(tenant, projectId)}/code-assistant`,
};
